export const PAGE_PATH_REGEXP = /\/.+\/[0-9]+/
export const BRAND_ID_REGEXP = /\/[0-9]+/

export const COMPATIBILITY_FIELD = 'compatibility'
